import { loader } from "graphql.macro";
import { executeGraphqlQuery } from "../../graphql/api";

const getAllAdjustersQuery = loader(
    "../../graphql/queries/searchAdjusters.graphql"
);
export const getAllAdjusters = (input: any) => {
    return executeGraphqlQuery(getAllAdjustersQuery, input);
}